/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useMemo } from 'react';
import { useCommandPaletteIsLoaded } from '@jira/compal__command-palette/src/controllers/command-palette/index.tsx';
import { getShortcutModifierKey } from '@atlassian/jira-common-components-keyboard-shortcuts-dialog/src/utils.tsx';
import { useAnalyticsEvents, fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { COMMAND_PALETTE_ID, COMMAND_PALETTE_PRESSED_ANALYTICS } from '../../common/constants.tsx';
import type { UseCommandPaletteShortcutResult } from './types.tsx';

export const useCommandPaletteShortcut = (): UseCommandPaletteShortcutResult => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const [{ isLoaded }, { open }] = useCommandPaletteIsLoaded();

	return useMemo(
		() => ({
			keyMap: {
				[`${getShortcutModifierKey()}+k`]: {
					callback: (ev?: KeyboardEvent) => {
						fireUIAnalytics(
							createAnalyticsEvent(COMMAND_PALETTE_PRESSED_ANALYTICS),
							COMMAND_PALETTE_ID,
							{
								key: 'k',
								isLoaded,
							},
						);

						ev?.preventDefault();
						open();
					},
				},
			},
		}),
		[createAnalyticsEvent, isLoaded, open],
	);
};
